// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121305/js/" + chunkId + "." + {"44":"8b547a93","225":"c5111fc5","481":"7b67d1cd","486":"b8066dd7","770":"dcbfc7c3"}[chunkId] + ".0.4200293609030148.chunk.js";
};